import { getWithRetry } from './fetch';

const apiGetSystemControls = async ( setSystemControls, dispatch ) => {
    await getWithRetry( 'apiGetSystemControls', 
        '/api/systemcontrols', setSystemControls,
        dispatch, 30, 5000
    );
}

export default apiGetSystemControls;
